'use client';

import { useEffect } from 'react';
import {
  getPermateParams,
  savePermateParamsToSession,
} from '@/lib/permate-tracking';

/**
 * Component để khởi tạo Permate tracking parameters
 * Đặt component này trong layout hoặc trang chính để capture tracking params
 */
export function PermateTrackingInit() {
  useEffect(() => {
    // Capture và lưu Permate parameters khi trang load
    const params = getPermateParams();

    if (Object.values(params).some((v) => v)) {
      console.log('Permate tracking initialized:', params);
      savePermateParamsToSession(params);
    }
  }, []);

  // Component này không render gì cả, chỉ thực hiện logic tracking
  return null;
}

/**
 * Hook để sử dụng Permate tracking trong components
 */
export function usePermateTracking() {
  return {
    getParams: getPermateParams,
    saveParams: savePermateParamsToSession,
  };
}
